import {AjaxAddToCart} from 'extensions/AjaxAddToCart';
import AjaxAddToWishlist from 'extensions/AjaxAddToWishlist/AjaxAddToWishlist.js';
import {AnchorSmoothScroll} from 'extensions/anchor-smooth-scroll';
import {initCarousels} from 'extensions/carousel';
import 'extensions/quantify/quantify.js';
import 'extensions/toggle-details';
import 'extensions/ui-components/x-add-on-product';
import 'extensions/ui-components/x-capacity-flag';
import 'extensions/ui-components/x-flag';
import 'extensions/ui-components/x-product-card';
import 'extensions/ui-components/x-product-inventory-message';
import {PageManager} from 'genesis-packages/core';
import './PROD.scss';

export default class PROD extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {

		initCarousels();
		this.initProductImageGallery();
		this.initQuantityUpdates();
		this.initStickyHeader();

		/**
		 * Smooth scrolling for anchor links
		 */
		AnchorSmoothScroll.createFromSelector();

		/**
		 * Initialize ajax add to cart functionality
		 */
		new AjaxAddToCart('#js-purchase-form');

		/**
		 * This removes the default Miva `closeup_backing` container.
		 */
		var closeupBacking = document.querySelector('div.closeup_backing');

		window.addEventListener('load', function () {
			if (closeupBacking) {
				closeupBacking.parentNode.removeChild(document.querySelector('div.closeup_backing'));
			}
		});

		const atwlForm = document.getElementById('js-purchase-form');

		new AjaxAddToWishlist(
			atwlForm,
			{
				submitButtonElements: '.js-product-atwl'
			}
		);
	}

	initQuantityUpdates () {
		const form = document.getElementById('js-purchase-form');
		if (!form) {
			return;
		}

		const quantityElement = form.querySelector('[name="Quantity"]');
		const adpmQuantityElements = form.getElementsByClassName('js-quantity-value');

		if (!quantityElement || !adpmQuantityElements?.length) {
			return;
		}

		quantityElement.addEventListener('change', () => {
			for (const adpmQuantityElement of adpmQuantityElements) {
				adpmQuantityElement.value = quantityElement.value;
			}
		});
	}

	async initProductImageGallery () {
		const imageSliderElement = document.getElementById('js-product-layout-image-slider');

		if (!imageSliderElement) {
			return;
		}

		const {default: ProductImageGallery} = await import('extensions/product-image-gallery');

		new ProductImageGallery({
			productLayoutImageSlider: imageSliderElement,
			videos: this.pageContext.Product_Videos || []
		});
	}

	async initStickyHeader () {
		const stickyHeaderElement = document.getElementById('js-sticky-header');
		const atcElement = document.getElementsByClassName('js-add-to-cart')[0];

		if (!stickyHeaderElement || !atcElement || !('IntersectionObserver' in window)) {
			return;
		}

		const {default: ProductStickyHeader} = await import('extensions/product-sticky-header');

		new ProductStickyHeader(stickyHeaderElement, {
			stickyTargetElement: '.x-product-layout',
			targetAddToCartElement: atcElement,
			targetPriceValueElement: '.js-product-layout-details__pricing'
		});
	}

}
